import { Directive } from '@angular/core';
import { FlexDirective } from '@angular/flex-layout';

const selector = `[fxFlex.handset.landscape]`;
const inputs = ['fxFlex.handset.landscape'];

@Directive({
  selector, 
  inputs
})
export class CustomFxFlexHandsetLandscapeDirective extends FlexDirective {
  protected inputs = inputs;
}
